var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTpIconTraditional = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28201_16812)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F2F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3382 17.7021L43.6606 14.3238L47.5813 18.3336L34.3577 22.0198L31.3382 17.7021Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6553 17.2449C45.7049 18.3021 45.2984 18.5952 44.9567 18.3189C44.6149 18.0426 45.4933 18.0745 45.1028 17.9284C44.7123 17.7823 43.5577 18.0922 44.0296 18.4172C44.5015 18.7421 44.1438 18.905 43.7533 18.7589C43.3629 18.6128 42.3375 17.784 43.2646 17.6858",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7492 17.445L32.3399 18.0578",
    stroke: "#9D9DBF",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2404 15.027L40.8311 15.6398",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3052 17.8083L32.8959 18.4211",
    stroke: "#9D9DBF",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8298 18.4031L33.7298 19.7347",
    stroke: "#9D9DBF",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5575 17.7021L40.8799 14.3238L44.8007 18.3336L31.5771 22.0198L28.5575 17.7021Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8742 17.2449C42.9237 18.3021 42.5173 18.5952 42.1755 18.3189C41.8338 18.0426 42.7121 18.0745 42.3216 17.9284C41.9311 17.7823 40.7765 18.0922 41.2485 18.4172C41.7204 18.7421 41.3627 18.905 40.9722 18.7589C40.5817 18.6128 39.5564 17.784 40.4835 17.6858",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9681 17.445L29.5588 18.0578",
    stroke: "#9D9DBF",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4598 15.027L38.0505 15.6398",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5241 17.8083L30.1148 18.4211",
    stroke: "#9D9DBF",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0486 18.4031L30.9487 19.7347",
    stroke: "#9D9DBF",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2219 16.3115L37.5443 12.9332L41.4651 16.943L28.2415 20.6291L25.2219 16.3115Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.253032
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.538 15.8543C39.5875 16.9115 39.1811 17.2045 38.8393 16.9283C38.4976 16.652 39.3759 16.6839 38.9855 16.5378C38.595 16.3917 37.4403 16.7016 37.9123 17.0265C38.3842 17.3515 38.0265 17.5144 37.636 17.3683C37.2455 17.2222 36.2202 16.3934 37.1473 16.2952",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6325 16.0544L26.2232 16.6672",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1236 13.6364L34.7143 14.2492",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1879 16.4176L26.7786 17.0304",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7125 17.0125L27.6125 18.3441",
    stroke: "#9D9DBF",
    strokeWidth: 0.101213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1318 33.3535L32.4873 44.8447L21.7529 43.3105L44.3711 30.2715L54.1318 33.3535Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3157 43.4551C28.4919 41.5328 29.0411 40.709 29.865 40.9836C30.6888 41.2582 29.0411 41.8074 29.865 41.8074C30.6888 41.8074 32.6111 40.4344 31.5127 40.1598C30.4142 39.8852 30.9634 39.3359 31.7873 39.3359C32.6111 39.3359 35.0826 40.1598 33.4349 40.9836",
    stroke: "#9D9DBF",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6373 35.4938L52.0311 33.2969",
    stroke: "#9D9DBF",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.259 43.732L36.6528 41.5352",
    stroke: "#9D9DBF",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4404 35.4938L49.8342 33.2969",
    stroke: "#9D9DBF",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5544 39.3352L42.6943 34.9414",
    stroke: "#9D9DBF",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1454 28.8768L11.4392 21.761L11.7626 18.2031H17.9081L22.1128 24.9954H20.1722L17.9081 21.1141V24.9954L19.5253 29.5237V39.227L20.4956 39.8739H15.9674V29.8471L14.0268 25.6423L13.0564 31.1409L6.26411 35.9925L5.94066 36.9629L4 33.0815L10.1454 28.8768Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.234772,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2425 35.1815L17.3377 16.9111C17.3377 16.9111 17.2528 16.7908 17.1203 16.5876C16.8522 16.1765 16.3893 15.4262 16.0411 14.647C15.6578 13.7893 15.4134 12.8966 15.7205 12.3828C16.1355 11.6886 16.5615 11.3478 17.3378 11.089C18.114 10.8302 18.955 11.1968 19.2784 11.4124L19.8288 12.3828L20.8956 14.2638L31.5693 33.0832L32 37.288V39.4308L30.1573 38.1315L27.2425 35.1815Z",
    fill: "#00D2A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 37.288L31.5693 33.0832L20.8956 14.2638L19.8288 12.3828L19.2784 11.4124C18.955 11.1968 18.114 10.8302 17.3378 11.089C16.5615 11.3478 16.1355 11.6886 15.7205 12.3828C15.4134 12.8966 15.6578 13.7893 16.0411 14.647C16.3893 15.4262 16.8522 16.1765 17.1203 16.5876C17.2528 16.7908 17.3377 16.9111 17.3377 16.9111L27.2425 35.1815L30.1573 38.1315L32 39.4308V37.288ZM27.2425 35.1815L31.5693 33.0832M32 37.288L30.1573 38.1315",
    stroke: "#118F72",
    strokeWidth: 0.234772
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8436 20.1438C11.8436 19.8203 11.5201 19.1735 12.167 18.2031L14.4311 20.1438L16.3718 22.0844L20.9 20.4672L21.8703 18.5266C22.2493 18.112 22.4617 18.1115 22.8406 18.5266L22.5172 19.4969H24.7813C24.9339 19.6822 24.8249 19.963 24.5882 20.0032C23.9961 20.1039 23.5263 20.2236 22.8406 20.4672H25.1048V21.1141L23.3834 21.36C23.2788 21.375 23.2747 21.5244 23.3782 21.5451L24.4579 21.761V22.0844H22.5172L16.3718 24.9954C15.7249 24.672 11.8436 20.4672 11.8436 20.1438Z",
    fill: "#1C77EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.167 18.2031C11.5201 19.1735 11.8436 19.8203 11.8436 20.1438C11.8436 20.4615 15.5896 24.5254 16.3347 24.9748C16.3594 24.9897 16.387 24.9882 16.4131 24.9759L22.4981 22.0935C22.5107 22.0875 22.5244 22.0844 22.5383 22.0844H24.364C24.4158 22.0844 24.4579 22.0424 24.4579 21.9905V21.838C24.4579 21.7932 24.4263 21.7547 24.3824 21.7459L23.3782 21.5451C23.2747 21.5244 23.2788 21.375 23.3834 21.36L25.0241 21.1256C25.0704 21.119 25.1048 21.0794 25.1048 21.0327V20.5611C25.1048 20.5093 25.0627 20.4672 25.0108 20.4672H22.8837C22.8599 20.4672 22.8406 20.448 22.8406 20.4242C22.8406 20.4038 22.855 20.3862 22.8749 20.3821L24.707 20.0021C24.8912 19.964 24.9722 19.7465 24.8579 19.5971C24.8096 19.5339 24.7347 19.4969 24.6552 19.4969H22.6475C22.5834 19.4969 22.5381 19.4341 22.5584 19.3733L22.8224 18.5814C22.8336 18.5478 22.8249 18.5105 22.7994 18.4859C22.4503 18.1511 22.2396 18.1823 21.8826 18.515C21.8746 18.5225 21.8678 18.5316 21.8629 18.5415L20.9169 20.4335C20.906 20.4551 20.8873 20.4718 20.8644 20.4799L16.4277 22.0645C16.3936 22.0767 16.3554 22.0681 16.3297 22.0424L14.4311 20.1438",
    stroke: "#2D5AD9",
    strokeWidth: 0.234772,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3468 22.8711H26.641C26.8618 22.8711 27.0408 23.0501 27.0408 23.2709C27.0408 23.4223 26.9553 23.5607 26.8198 23.6284L26.394 23.8414L26.7174 24.3495L26.967 24.2247C27.1899 24.1132 27.461 24.1953 27.5847 24.4117L28.5645 26.1263C28.6245 26.2314 28.6417 26.3557 28.6123 26.4731L28.4766 27.016C28.4037 27.3074 28.0798 27.4565 27.8111 27.3221L27.7449 27.289C27.707 27.2701 27.6725 27.2452 27.6426 27.2153L27.593 27.1657C27.4667 27.0394 27.4667 26.8346 27.593 26.7083L27.6411 26.6602C27.671 26.6303 27.6877 26.5898 27.6877 26.5476C27.6877 26.4293 27.5632 26.3524 27.4574 26.4053L27.2122 26.5279C27.1099 26.579 26.9863 26.559 26.9054 26.4781C26.8016 26.3743 26.8016 26.206 26.9054 26.1021L27.156 25.8516C27.2328 25.7747 27.1784 25.6432 27.0697 25.6432C27.0507 25.6432 27.032 25.6476 27.0151 25.6561L26.8033 25.762C26.5772 25.875 26.3023 25.7834 26.1893 25.5573C26.1158 25.4104 26.1267 25.2355 26.2178 25.0988L26.7174 24.3495L26.394 23.8414L26.1469 23.7178C25.9261 23.6074 25.8366 23.3389 25.947 23.1181C26.0227 22.9667 26.1775 22.8711 26.3468 22.8711Z",
    fill: "#1C77EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.394 23.8414L26.8198 23.6284C26.9553 23.5607 27.0408 23.4223 27.0408 23.2709C27.0408 23.0501 26.8618 22.8711 26.641 22.8711H26.3468C26.1775 22.8711 26.0227 22.9667 25.947 23.1181C25.8366 23.3389 25.9261 23.6074 26.1469 23.7178L26.394 23.8414ZM26.394 23.8414L26.7174 24.3495M26.7174 24.3495L26.967 24.2247C27.1899 24.1132 27.461 24.1953 27.5847 24.4117L28.5645 26.1263C28.6245 26.2314 28.6417 26.3557 28.6123 26.4731L28.4766 27.016C28.4037 27.3074 28.0798 27.4565 27.8111 27.3221L27.7449 27.289C27.707 27.2701 27.6725 27.2452 27.6426 27.2153L27.593 27.1657C27.4667 27.0394 27.4667 26.8346 27.593 26.7083L27.6411 26.6602C27.671 26.6303 27.6877 26.5898 27.6877 26.5476C27.6877 26.4293 27.5632 26.3524 27.4574 26.4053L27.2122 26.5279C27.1099 26.579 26.9863 26.559 26.9054 26.4781C26.8016 26.3743 26.8016 26.206 26.9054 26.1021L27.156 25.8516C27.2328 25.7747 27.1784 25.6432 27.0697 25.6432C27.0507 25.6432 27.032 25.6476 27.0151 25.6561L26.8033 25.762C26.5772 25.875 26.3023 25.7834 26.1893 25.5573C26.1158 25.4104 26.1267 25.2355 26.2178 25.0988L26.7174 24.3495Z",
    stroke: "#2D5AD9",
    strokeWidth: 0.234772,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3152 13.4805H17.3621C17.7141 13.4805 17.9994 13.7658 17.9994 14.1177C17.9994 14.4696 17.7141 14.7549 17.3621 14.7549H17.3152C16.9633 14.7549 16.678 14.4696 16.678 14.1177C16.678 13.7658 16.9633 13.4805 17.3152 13.4805Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.234772,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4767 15.6067C13.3616 14.6993 13.3618 13.9037 13.4796 12.9731C13.5913 12.0906 14.3772 11.4688 15.2668 11.4688H15.4373C16.4025 11.4688 17.2201 12.2001 17.2856 13.163C17.3434 14.0121 17.3574 14.739 17.3121 15.4975C17.2567 16.4247 16.4509 17.1033 15.522 17.1033H15.2597C14.3734 17.1033 13.5882 16.4859 13.4767 15.6067Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.234772,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0891 13.3477H13.136C13.488 13.3477 13.7733 13.633 13.7733 13.9849C13.7733 14.3368 13.488 14.6221 13.136 14.6221H13.0891C12.7372 14.6221 12.4519 14.3368 12.4519 13.9849C12.4519 13.633 12.7372 13.3477 13.0891 13.3477Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.234772,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28201_16812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTpIconTraditional);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tp_icon_traditional.387c18934cf93c0e8d5b59f552d1750c.svg";